import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import indianFamily from '../../Image/indianFamily.png';
const SolarRoiModal = ({
  open,
  onClose,
  state,
  minBill,
  maxBill,
  consent,
  imageUrl = '/api/placeholder/400/320', // Default placeholder image
}) => {
  const navigate = useNavigate();
  const [countDown, setCountDown] = useState(6);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [type, setType] = useState(true);

  useEffect(() => {
    let timer;
    if (open) {
      setIsRedirecting(true);
    }

    if (isRedirecting && countDown > 0) {
      timer = setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else if (isRedirecting && countDown === 0) {
      handleRedirect();
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open, isRedirecting, countDown]);

  const handleRedirect = () => {
    navigate('/dashboard');
    onClose();
  };

  const handleManualRedirect = () => {
    setCountDown(0);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          minHeight: '400px',
        }}
      >
        {/* Left side - Image */}
        <Box
          sx={{
            flex: { xs: '1', sm: '1' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f5f5f5',
          }}
        >
          <img
            src={indianFamily}
            alt='Solar panel installation'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Right side - Content */}
        <Box
          sx={{
            flex: { xs: '1', sm: '1.2' },
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <DialogTitle mt={4}>
            {type ? (
              <Typography variant='h5' fontWeight={'900'} mb={2}>
                Congratulations on beginning your solar journey!
              </Typography>
            ) : (
              <Typography variant='h5' fontWeight={'900'} mb={2}>
                Hang tight!
              </Typography>
            )}
          </DialogTitle>

          <DialogContent sx={{ flex: 1 }}>
            {type ? (
              <DialogContentText mb={2}>
                We'll reach out soon to create your quote.
              </DialogContentText>
            ) : (
              <DialogContentText mb={2}>
                We're working on expanding to more locations
              </DialogContentText>
            )}
            {type ? (
              <>
                <Typography variant='subtitle1' fontWeight='bold' mb={1}>
                  Want to be ready when we call?
                </Typography>
              </>
            ) : (
              <>
                <Typography variant='subtitle1' fontWeight='bold' mb={4}>
                  Use our verified install list
                </Typography>
              </>
            )}

            {type ? (
              <>
                <Typography variant='body1' mb={2}>
                  Keep below handy:
                  <ul style={{ listStyleType: 'disc', marginLeft: '30px' }}>
                    <li>Latest electricity bill</li>
                    <li>Usage history</li>
                  </ul>
                </Typography>
              </>
            ) : (
              <>
                <Stack direction='row' spacing={1}>
                  <Typography variant='body' mb={2}>
                    Questions?
                  </Typography>
                  <Typography
                    variant='body'
                    mb={2}
                    sx={{ textDecoration: 'underline' }}
                  >
                    Contact Us
                  </Typography>
                </Stack>
              </>
            )}
            <Button
              onClick={handleManualRedirect}
              variant='contained'
              color='primary'
              sx={{ marginBottom: '20px', textTransform: 'none' }}
            >
              See my dashboard
            </Button>

            {/* Place DialogActions here, between content */}

            {/* Remaining content below the buttons */}
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Typography variant='body1'>
                Auto redirects in {countDown}s
              </Typography>
            </Box>
          </DialogContent>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SolarRoiModal;
